"use client";

import * as React from "react";
import { PopupInfo } from "components/PopupInfo/PopupInfo";
import { cn } from "@/lib/utils";
import { homeCardVariants } from "../foundations/home-variants";
import { HomeLoadingStateV2 } from "./HomeLoadingStateV2";

export interface HomeValueBadgeCardV2Props {
  title: string;
  value: number;
  percent?: boolean;
  badgeTone?: "default" | "danger" | "success" | "brand";
  loading: boolean;
  popupInfo?: string;
  icon?: React.ReactNode;
}

export function HomeValueBadgeCardV2({
  title,
  value,
  percent,
  badgeTone = "default",
  loading,
  popupInfo,
  icon
}: HomeValueBadgeCardV2Props) {
  return (
    <div className="relative">
      <div className={cn(homeCardVariants({ variant: "metric" }), "min-h-[90px] border-2 p-3")}>
        <div className="flex h-full flex-col items-center justify-center gap-2">
          {!loading ? (
            <span
              className={cn(
                "flex h-[50px] w-[50px] items-center justify-center rounded-full p-3 text-xl font-bold",
                badgeTone === "default" && "bg-slate-200 dark:bg-zinc-700",
                badgeTone === "danger" && "bg-red-500 text-white",
                badgeTone === "success" && "bg-green-500 text-white",
                badgeTone === "brand" && "bg-blue-300 dark:bg-blue-900"
              )}
            >
              {!percent ? value : `${value}%`}
            </span>
          ) : (
            <HomeLoadingStateV2 inline compact />
          )}
          <span className="text-center text-xs text-slate-500 dark:text-zinc-400">{title}</span>
        </div>
      </div>
      {icon && <div className="absolute right-2 top-2">{icon}</div>}
      {popupInfo && (
        <div className={cn("absolute right-2", icon ? "bottom-2" : "top-2")}>
          <PopupInfo className="ml-2 self-center" label={popupInfo} placement="bottomEnd" />
        </div>
      )}
    </div>
  );
}
